// extracted by mini-css-extract-plugin
export default {"button":"CreatePostBaseForCampaignModal_button__f3MoQ","modal":"CreatePostBaseForCampaignModal_modal__n7ikm"};